// 用于新品,把一些无关紧要的东西关闭;如微软聊天,IP站点选择
export const NoneShowPathnameArray = ['/wave-3-portable-air-conditioner', '/delta-pro-ultra-x'];
